import styled from 'styled-components';
const IndexStyled = styled.div`
  height: 100%;
  .export-wrapper {
    margin: 24px 0;
    padding-left: 32px;
    height: 34px;
    .export {
      width: 107px;
      border-radius: 24px;
      color: #fff;
      .MuiSvgIcon-root {
        margin-right: 6px;
      }
    }
  }
  .single_component1 {
    margin-bottom: 0;
  }
  .single_component2 {
    margin-bottom: 4px;
  }
  .single_component {
    margin-top: 4px;
    flex-grow: 1;
  }
  .action_btn_group {
    margin-right: 1rem;
    display: flex;
    > div {
      margin-right: 10px;
    }
  }
  .mm_content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .contentMsg {
    text-align: center;
    margin-bottom: 10px;
    font-size: 18px;
  }

  .editDetail {
    display: flex;
    justify-content: center;

    > div {
      margin-right: 20px;
    }
  }
`;
export default IndexStyled;
